const categorySelect = document.getElementById('category-select');
const filterTitle = document.getElementById('filter-title');
const breadcrumb = document.getElementById('blog-breadcrumb')

if(categorySelect){
  const options = categorySelect.querySelectorAll('option');
  const currentUrl = window.location.pathname;
  const urlSplit = currentUrl.split('/');
  let blogName = urlSplit[2];
  console.log(blogName);
  if(currentUrl.includes('tagged')){
    const option = urlSplit[urlSplit.length - 1];
    const selectedOption = categorySelect.querySelector(`option[data-link="${option}"]`);
    categorySelect.value = selectedOption.value;
    if (filterTitle) {
      const filterName = selectedOption.value.replace("filter-", "");
      filterTitle.textContent = filterName;
      breadcrumb.textContent = filterName;
    }
    
      
  }
  categorySelect.addEventListener('change', (e) => {
    if(e.target.value == "all"){
      window.location.href = `/blogs/${blogName}`;
    }
    else{
      const link = options[e.target.selectedIndex].dataset.link;
      window.location.href = `/blogs/${blogName}/tagged/${link}`;
    }
  })
}